// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".points-table[data-v-7341148c]{border:1px solid #455fed;border-radius:.7rem;margin-top:.5rem;max-width:13rem;padding:.5rem 1rem}.custom-range[data-v-7341148c]{height:2.2rem}.custom-switch[data-v-7341148c]{padding-left:2.25rem}input[type=number][data-v-7341148c]::-webkit-inner-spin-button,input[type=number][data-v-7341148c]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-7341148c]{-moz-appearance:textfield}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
